<app-inline-dialog
  [visible]="visible() && !minimized()"
  (onHide)="onDialogHide()"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="true"
  [resizable]="false"
  [closable]="true"
  [showHeader]="false"
  appendTo="body"
  styleClass="ai-assistant-dialog"
  [style]="{
    width: '420px',
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    margin: '0'
  }"
>
  <div class="assistant-container" [attr.data-lang]="uiLanguage()">
    <!-- Header -->
    <div class="assistant-header">
      <div class="flex items-center gap-sm">
        <div class="icon-orb">
          <ic-sparkles
            startColor="white"
            endColor="white"
            [width]="20"
            [height]="20"
          ></ic-sparkles>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-bold text-white tracking-wide">
            {{ 'aiAssistantUserGuide' | translate }}
          </span>
          <span class="text-[10px] text-white/80 uppercase font-semibold">
            {{
              currentView() === 'menu'
                ? ('tutorialLibrary' | translate)
                : (selectedTutorial()?.title ?? '' | translate)
            }}
          </span>
        </div>
      </div>
      <button class="close-btn" (click)="onClose()">✕</button>
    </div>

    <!-- MAIN MENU VIEW -->
    @if (currentView() === 'menu') {
    <div class="assistant-body menu-view" @messageAnimation>
      <div class="welcome-section">
        <h3 class="text-md font-bold text-slate-800">
          {{ 'aiHelloTitle' | translate }}
        </h3>
        <p class="text-xs text-slate-500 mt-1">
          {{ 'aiWelcomeMsg' | translate }}
        </p>
      </div>

      <div class="chips-list">
        @for (tutorial of tutorials; track tutorial.id) {
        <div
          appClickable
          class="tutorial-chip"
          (click)="selectTutorial(tutorial)"
        >
          <div class="chip-icon">
            @if (tutorial.iconType === 'templates') {
            <ic-declaration-template
              [width]="12"
              [height]="12"
              startColor="var(--color-primary-start-color)"
              endColor="var(--color-primary-end-color)"
            ></ic-declaration-template>
            } @else if (tutorial.iconType === 'plane') {
            <ic-plane
              [width]="15"
              [height]="15"
              startColor="var(--color-primary-start-color)"
              endColor="var(--color-primary-end-color)"
            ></ic-plane>
            } @else {
            <ic-sparkles
              [width]="14"
              [height]="14"
              startColor="var(--color-primary-start-color)"
              endColor="var(--color-primary-end-color)"
            ></ic-sparkles>
            }
          </div>
          <div class="chip-content">
            <span class="chip-title">{{ tutorial.title | translate }}</span>
            <span
              class="chip-desc text-[10px] text-slate-400 leading-tight block"
              >{{ tutorial.description | translate }}</span
            >
          </div>
          <div class="chip-arrow text-light-text">→</div>
        </div>
        }
      </div>
    </div>
    }

    <!-- TUTORIAL FLOW VIEW -->
    @if (currentView() === 'tutorial' && selectedTutorial()) {
    <div class="flow-container" @messageAnimation>
      <!-- Step Indicator Header -->
      <div class="step-indicator-bar">
        <span
          class="text-[10px] font-bold text-slate-400 uppercase tracking-widest"
        >
          {{
            'stepIndicator'
              | translate
                : {
                    current: currentStepIndex() + 1,
                    total: $safeNavigationMigration(
                      selectedTutorial()?.steps?.length
                    )
                  }
          }}
        </span>
      </div>

      <!-- Content Area -->
      <div class="assistant-body tutorial-view">
        <div class="chat-bubble">
          <div class="bubble-content">
            <span
              class="step-label"
              >{{ (selectedTutorial()?.steps?.[currentStepIndex()]?.title ?? '') | translate }}</span
            >
            <p class="mt-xs">
              {{ (selectedTutorial()?.steps?.[currentStepIndex()]?.assistantMessage ?? '') | translate }}
            </p>
          </div>
        </div>

        <!-- Step Image -->
        @if (selectedTutorial()?.steps?.[currentStepIndex()]?.image) {
        <div
          appClickable
          class="step-image-preview mt-sm cursor-pointer"
          (click)="previewImage()"
        >
          <img
            [src]="$safeNavigationMigration(selectedTutorial()?.steps?.[currentStepIndex()]?.image)"
            class="w-full h-[140px] object-cover rounded-xl border border-line shadow-sm hover:opacity-90 transition-all duration-300"
          />
          <div class="zoom-overlay rounded-xl">
            <div class="flex flex-col items-center gap-1">
              <span
                class="text-[10px] font-bold text-white uppercase tracking-widest drop-shadow-lg"
                >Click to expand</span
              >
            </div>
          </div>
        </div>
        }

        <!-- Action Instruction Card -->

        <div class="step-summary">
          <div class="info-badge">{{ 'proTipLabel' | translate }}</div>
          <p class="text-[11px] text-slate-500 font-medium italic">
            {{ (selectedTutorial()?.steps?.[currentStepIndex()]?.description ?? '') | translate }}
          </p>
        </div>
      </div>

      <!-- Footer -->
      <div class="assistant-footer">
        <button class="nav-btn" (click)="backToMenu()">
          {{ 'backToMenu' | translate }}
        </button>
        <div class="flex-1"></div>
        <div class="flex gap-xs">
          <button
            class="nav-btn"
            [disabled]="currentStepIndex() === 0"
            (click)="prevStep()"
          >
            {{ 'prev' | translate }}
          </button>
          <button class="action-btn" (click)="nextStep()">
            {{
              currentStepIndex() === selectedTutorial()!.steps.length - 1
                ? ('finish' | translate)
                : ('next' | translate)
            }}
          </button>
        </div>
      </div>
    </div>
    }
  </div>
</app-inline-dialog>
